import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import * as angular from "angular";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface JobRunService {
  getJobs(): angular.IPromise<apsViewModels.JobItem[]>;
  addJob(command: apsCommands.AddJob): angular.IPromise<any>;
  saveJob(command: apsCommands.UpdateJob): angular.IPromise<any>;
  deleteJob(job: apsViewModels.JobItem): angular.IPromise<any>;

  getJobRuns(shopId: string): angular.IPromise<apsViewModels.JobRunDisplayItem[]>;
  addJobRun(jobRun: apsViewModels.JobRunItem): angular.IPromise<any>;
  updateJobRun(jobRun: apsViewModels.JobRunItem): angular.IPromise<any>;
  restoreJobRun(command: apsCommands.RestoreJobRun): angular.IPromise<any>;
  getActive(plantId: string): angular.IPromise<apsViewModels.JobRunSummary[]>;
  getTarget(plantId: string, mold: string, finish: string, color:string): angular.IPromise<number>;
  getEquipmentByShopName(shopId: string): angular.IPromise<string[]>;
}

export default angular
  .module('aps.services.jobRun', [HttpServiceName])
  .service('jobRunService', function (httpService: HttpService): JobRunService {

    function getJobs() {
      return httpService.get<apsViewModels.JobItem[]>(Endpoints.JOBS, {includeDeleted: true});
    }

    function addJob(command: apsCommands.AddJob) {
      return httpService.post<any>(Endpoints.JOBS, command);
    }

    function saveJob(command: apsCommands.UpdateJob) {
      return httpService.put<any>(Endpoints.JOBS, command);
    }

    function deleteJob(job: apsViewModels.JobItem) {
      return httpService.delete<any>(Endpoints.JOBS + '/' + job.id);
    }

    function getJobRuns(shopId: string) {
      return httpService.get<apsViewModels.JobRunDisplayItem[]>(Endpoints.JOB_RUNS, {shopId: shopId});
    }

    function addJobRun(jobRun: apsViewModels.JobRunItem) {
      return httpService.post<any>(Endpoints.JOB_RUNS, jobRun);
    }

    function updateJobRun(jobRun: apsViewModels.JobRunItem) {
      return httpService.put<any>(Endpoints.JOB_RUNS, jobRun);
    }

    function restoreJobRun(command: apsCommands.RestoreJobRun) {
      return httpService.put<any>(Endpoints.JOB_RUN_RESTORE, command);
    }

    function getActive(plantId: string) {
      return httpService.get<apsViewModels.JobRunSummary[]>(Endpoints.JOB_RUNS_ACTIVE, {plantId: plantId});
    }
    function getTarget(plantId: string, mold: string, finish: string, color:string) {
      return httpService.get<number>(Endpoints.JOB_RUNS_TARGET, {plantId: plantId, mold: mold, finish: finish, color: color});
    }
    function getEquipmentByShopName(shopId: string){
      return httpService.get<string[]>(Endpoints.LINE_EQUIPMENT_BY_SHOP, {shopId : shopId});
    }
    return {
      getJobs: getJobs,
      addJob: addJob,
      saveJob: saveJob,
      deleteJob: deleteJob,
      getJobRuns: getJobRuns,
      addJobRun: addJobRun,
      updateJobRun: updateJobRun,
      restoreJobRun: restoreJobRun,
      getActive: getActive,
      getTarget: getTarget,
      getEquipmentByShopName: getEquipmentByShopName
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/jobs/jobRun.service.ts